import { h, Component } from 'preact';
import s from 'components/bolt/dualMenu/dualMenu.sss';
import Store from 'store/store';
import { joinClasses, accessNested, sortObjectByOrder } from 'utils/utils';

export default class DualMenu extends Component {

	constructor(props) {
		super(props);

		this.findPageOrder = this.findPageOrder.bind(this);
	}

	checkTabActive(type) {
		if (this.props.isWidget === type) {
			return true;
		}
		const store = Store.get();
		const activePage = store.activePage;

		if (
			activePage === 'boltHomeEnt' && type === 'homeEnt' ||
			activePage === 'boltShowtimes' && type === 'showtimes'
		) {
			return true;
		}
		return store[type].show === activePage;
	}

	renderButton(type, text) {
		const active = this.checkTabActive(type);

		return (
			<button
				class={joinClasses(s.button, active && s.active, 'mediumB')}
				onClick={() => Store.emit('SWITCH_DUAL_VIEW', type, this.props.isWidget)}
				key={type}
			>
				<span>{text}</span>
			</button>
		);
	}

	findPageOrder(pageType) {
		const pages = this.props.pages || Object.values(Store.get().appData.pages);
		const page = pages?.find(page => page.type === pageType);
		return page?.order;
	}

	render(props) {
		const store = Store.get();
		const copy = accessNested(store, 'appData.copy.baseCopy', {});

		const showtimesCopy = props.widgetData?.dualMenuShowtimesCopy || copy.$DUAL_VIEW_SHOWTIMES_BTN;
		const homeEntCopy = props.widgetData?.dualMenuHomeEntCopy || copy.$DUAL_VIEW_HOMEENT_BTN;

		let elements = sortObjectByOrder([
			{
				order: this.findPageOrder('showtimes'),
				component: this.renderButton('showtimes', showtimesCopy || 'Watch in cinemas')
			},
			{
				order: this.findPageOrder('homeEnt'),
				component: this.renderButton('homeEnt', homeEntCopy || 'Watch at home')
			},
		], value => value.component);

		return (
			<div class={joinClasses(s.wrapper, props.isWidget && s.widget)}>
				{elements}
			</div>
		);
	}
}
